<div class="flex flex-col gap-2 lg:hidden">
  @if (industries()?.length > 0) {
    @for (industry of industries(); track industry?.id) {
      <div
        class="flex w-full min-w-0 items-center p-4 rounded-md bg-proffeo-surface border border-proffeo-border gap-4"
      >
        <div
          class="flex items-center justify-center w-10 h-10 aspect-square bg-proffeo-action-primary rounded-full shrink-0"
        >
          <mat-icon
            fontIcon="construction"
            class="icon-white"
          />
        </div>
        <div class="flex min-w-0 flex-1 items-center gap-2">
          <p class="min-w-0 flex-1 break-words">{{ industry?.name }}</p>
          <mat-icon
            [matMenuTriggerFor]="matIndustriesMenu"
            fontIcon="more_vert"
            class="cursor-pointer"
          />
          <mat-menu #matIndustriesMenu>
            <div class="flex h-full w-full flex-col">
              <div
                (click)="onEditIndustry(industry)"
                class="flex cursor-pointer w-full gap-1 items-center px-4 py-2 group hover:bg-proffeo-accent transition-default"
              >
                <mat-icon
                  fontIcon="edit"
                  class="group-hover:icon-white"
                />
                <p class="group-hover:icon-white">
                  {{ 'company-industries.list-actions.edit' | translate }}
                </p>
              </div>
              <div
                (click)="onDeleteIndustry(industry)"
                class="flex cursor-pointer w-full gap-1 items-center px-4 py-2 group hover:bg-proffeo-accent transition-default"
              >
                <mat-icon
                  fontIcon="delete"
                  class="group-hover:icon-white"
                />
                <p class="group-hover:icon-white">
                  {{ 'company-industries.list-actions.delete' | translate }}
                </p>
              </div>
            </div>
          </mat-menu>
        </div>
      </div>
    }
  } @else {
    <div class="flex w-full p-4 items-center justify-center">
      <p>{{ 'placeholders.no-results-found' | translate }}</p>
    </div>
  }
</div>

<div class="hidden lg:flex w-full">
  <proffeo-ui-table
    (actionClick)="onTableAction($event)"
    [columns]="columns()"
    [emptyText]="'placeholders.no-results-found' | translate"
    [rowActions]="rowActions()"
    [rowId]="resolveRowId"
    [rows]="industries()"
    [tableAriaLabel]="'company-industries.table-headers.name' | translate"
    orderMode="none"
    class="w-full"
  />
</div>
